import React, { useState, useEffect, useRef } from 'react';

import { arrowRedoOutline } from 'ionicons/icons';
import ChatBotRisp from '../../services/chatbot';
import '../../theme/chatbot.css';
import {
  IonRow,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonList,
  IonFooter,
  IonPage,
  IonGrid,
  IonCol,
  IonIcon,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
} from '@ionic/react';

const ChatBot = () => {
  const containerRef = useRef(null);
  const [text, setText] = useState('');
  const [messages, setMessages] = useState([]);
  const [suggestions] = useState([]);
  const [subcategoriesForCategory, setSubcategoriesForCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const messagesEndRef = useRef(null);
  const [question, setQuestion] = useState('');

  useEffect(() => {
    const container = containerRef.current;
    if (container) container.addEventListener('click', handleClick);
  }, [messages]);

  useEffect(() => {
    if (text.trim() !== '') {
      (async () => {
        await insertQuestion();
        await askQuestion();
      })();
    }
  }, [submit]);

  const handleInputChange = (event) => setText(event.target.value);

  const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);
  const handleSubmit = async () => setSubmit(true);
  const handleClick = async (event) => {
    if (event.target && event.target.classList.contains('chatToInput')) {
      const newQuestion = event.target.dataset.question || '';

      setQuestion(newQuestion);
      setText(event.target.textContent);
      setSubmit(true);
    }
  };

  const updateScrollbar = () => {
    if (messagesEndRef.current) {
      setTimeout(() => {
        messagesEndRef.current.scrollTo({
          top: messagesEndRef.current.scrollHeight,
          behavior: 'smooth',
        });
      }, 100);
    }
  };

  const insertQuestion = async () => {
    const userMessage = { sender: 'user', text };

    setMessages((prevMessages) => [...prevMessages, userMessage]);
    updateScrollbar();

    setTimeout(() => {
      setLoading(true);
      updateScrollbar();
    }, randomInt(500, 1500));
  };

  const askQuestion = async () => {
    try {
      let rawResp = await ChatBotRisp.risposta(`${question} ${text}`);
      setText('');

      insertAnswer(rawResp?.original ?? rawResp);
    } catch (error) {
      insertAnswer('Scusami, non riesco a capire la tua richiesta. Puoi ripetere inserendo più informazioni? grazie!');
      console.error("Errore durante l'invio al backend:", error);
    }
  };

  const insertAnswer = (resp) => {
    setTimeout(() => {
      if (Array.isArray(resp)) {
        resp.forEach((service) => {
          setMessages((prevMessages) => [
            ...prevMessages,
            {
              sender: 'bot',
              text: typeof service === 'string' ? service : service.response,
              link: service.link ?? null,
              textLink: service.textLink ?? 'Apri',
              suggestions: service.suggestions ?? [],
            },
          ]);
        });
      } else {
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            sender: 'bot',
            text: typeof resp === 'string' ? resp : resp?.response ?? JSON.stringify(resp),
            suggestions: Array.isArray(resp.suggestions) ? resp.suggestions : [],
          },
        ]);
      }

      setLoading(false);
      updateScrollbar();
      setSubmit(false);
    }, randomInt(2000, 4000));
  };

  const handleCategorySelect = (category) => {
    setLoading(true);
    const selectedCategory = messages.find(
      (message) => message.suggestions && message.suggestions.some((s) => s.card.title === category)
    );

    if (selectedCategory) {
      const subcategoriesForCategory = selectedCategory.suggestions.find((s) => s.card.title === category);
      setSubcategoriesForCategory(subcategoriesForCategory.card);
    }

    const userMessage = { sender: 'user', text: category };

    setMessages((prevMessages) => [...prevMessages, userMessage]);
    setLoading(false);
  };

  const handleCategorySelection = async (subcategory, postback) => {
    if (!suggestions || suggestions.length === 0) setSubcategoriesForCategory(null);
    setLoading(true);
    const userMessage = { sender: 'user', text: subcategory };

    setMessages((prevMessages) => [...prevMessages, userMessage]);

    try {
      let resp = await ChatBotRisp.risposta(subcategory);

      setTimeout(() => {
        if (Array.isArray(resp)) {
          resp.forEach((service) => {
            const botMessage = {
              sender: 'bot',
              text: service.response,
              link: service.link,
              textLink: service.textLink ?? 'Apri',
              suggestions: service.suggestions,
            };
            setMessages((prevMessages) => [...prevMessages, botMessage]);
          });
        } else {
          const botMessage = {
            sender: 'bot',
            text: resp.response,
            suggestions: resp.suggestions,
          };
          setMessages((prevMessages) => [...prevMessages, botMessage]);
        }
      }, 1500);
    } catch (error) {
      console.error("Errore durante l'invio al backend:", error);
    }

    setLoading(false);
  };

  const presentationBotElement = () => {
    return (
      <IonItem className="message-wrapper new" lines="none">
        <IonLabel className="bot-message message">
          <div>
            Ciao! Sono l’assistente virtuale della Farmacia Daddi.
            <br />
            Alcune cose che posso fare:
            <ul style={{ paddingLeft: '24px' }}>
              <li>verificare la disponibilità di farmaci, integratori e altri prodotti</li>
              <li>cercare informazioni sui servizi offerti dalla farmacia</li>
              <li>guidarti nell’uso dell’app</li>
            </ul>
            Come posso aiutarti oggi?
          </div>
        </IonLabel>
      </IonItem>
    );
  };

  const dialogElement = (message, index) => {
    return (
      <div key={index}>
        <IonItem className="message-wrapper new" lines="none">
          <IonLabel ref={containerRef} className={`message ${message.sender === 'user' ? 'user-message' : ''}`}>
            <div dangerouslySetInnerHTML={{ __html: message.text }}></div>

            {typeof message.link == 'string' && (
              <a href={message.link} rel="noopener noreferrer" className="chatOption">
                {message.textLink}
              </a>
            )}
          </IonLabel>
        </IonItem>

        {
          message.suggestions
          // && (
          //   <IonItem lines="none" className="suggestions-container">
          //     <div
          //       className="suggestions"
          //       style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px' }}
          //     >
          //       {message.suggestions.map((suggestion, suggestionIndex) => (
          //         <IonButton
          //           key={suggestionIndex}
          //           className="p-2 bg-blue-500 text-white rounded-lg bg-color bot-message"
          //           onClick={() => handleCategorySelect(suggestion.card.title)}
          //         >
          //           {suggestion.card.title}
          //         </IonButton>
          //       ))}
          //     </div>
          //   </IonItem>
          // )
        }
      </div>
    );
  };

  const loadingElement = () => {
    return (
      <IonItem className="message-wrapper loading new" lines="none">
        <IonLabel className="message">
          <div>
            <span></span>
          </div>
        </IonLabel>
      </IonItem>
    );
  };

  return (
    <>
      <IonPage>
        <IonCard className="chat">
          <IonCardHeader>
            <IonRow className="ion-align-items-center ion-justify-content-center">
              <IonCol size="4">
                <img className="botimg" src="/assets/robot_02.png" alt="assistente virtuale" />
              </IonCol>

              <IonCol>
                <IonCardTitle>Assistente virtuale</IonCardTitle>
              </IonCol>
            </IonRow>
          </IonCardHeader>

          <IonCardContent className="messages-wrapper">
            <IonList className="messages" ref={messagesEndRef}>
              {presentationBotElement()}

              {messages.map((message, index) => dialogElement(message, index))}

              {subcategoriesForCategory?.buttons && (
                <IonItem lines="none" className="suggestions-container">
                  <div
                    className="suggestions"
                    style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px' }}
                  >
                    {Object.entries(subcategoriesForCategory.buttons).map(([subcategory, details], index) => (
                      <IonButton
                        key={index}
                        className="bg-color bot-message"
                        onClick={() => handleCategorySelection(subcategory, details.text)}
                      >
                        {subcategory}
                      </IonButton>
                    ))}
                  </div>
                </IonItem>
              )}

              {loading && loadingElement()}
            </IonList>
          </IonCardContent>

          <IonFooter className="ion-padding">
            <IonGrid className="p-0">
              <IonRow className="ion-align-items-center">
                <IonCol className="py-0">
                  <IonInput
                    className="chatInput"
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSubmit();
                      }
                    }}
                    value={text}
                    placeholder="Scrivi qui"
                    onIonChange={handleInputChange}
                  />
                </IonCol>

                <IonCol className="py-0" size="auto">
                  <IonButton color="light" onClick={handleSubmit}>
                    <IonIcon icon={arrowRedoOutline} slot="icon-only" />
                  </IonButton>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonFooter>
        </IonCard>
      </IonPage>
    </>
  );
};
export default ChatBot;
